// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__gBo8T","colBig":"styles_colBig__6_Fk8","colSmall":"styles_colSmall__19Rc3"};